require('jquery-ui/ui/effect');
require('jquery-ui/ui/effects/effect-shake');
require('jquery-ui/ui/unique-id');

// ---------------------------------------------- //
//                      Style                     //
// ---------------------------------------------- //
import '~/Content/shared/web/plugins/bootstrap-switch/css/bootstrap-switch.min.css';
import '~/Content/shared/web/css/aga.css';
import '~/Content/shared/web/css/aga.tile.css';
import '~/Content/shared/web/css/aga.grid.css';

// ---------------------------------------------- //
//                   JavaScript                   //
// ---------------------------------------------- //
require('~/Content/shared/web/plugins/bootstrap-switch/js/bootstrap-switch.min.js');

// Preparar globais
window.JUR = {};
window.AGA = {};
window.AGADash = {};

require('~/Content/shared/commom/gridCommands.js');

require('~/Content/shared/dynamic-query/dynamicquery.js');
require('~/Content/shared/web/js/quick-nav.js');
require('~/Content/shared/web/js/aga.js');
require('~/Content/shared/web/js/aga.revealhandles.js');
require('~/Content/shared/web/js/aga.menu.js');
require('~/Content/shared/web/js/aga.helper.js');
require('~/Content/shared/web/js/aga.loader.js');
require('~/Content/shared/web/js/aga.form.js');
require('~/Content/shared/web/js/aga.baseinputcontrol.js');
require('~/Content/shared/web/js/aga.lookup.js');
require('~/Content/shared/web/js/aga.text.js');
require('~/Content/shared/web/js/aga.number.js');
require('~/Content/shared/web/js/aga.date.js');
require('~/Content/shared/web/js/aga.checkbox.js');
require('~/Content/shared/web/js/aga.radio.js');
require('~/Content/shared/web/js/aga.ajax.js');
require('~/Content/shared/web/js/aga.grid.js');
require('~/Content/shared/web/js/aga.textdecorator.js');
require('~/Content/shared/web/js/aga.page.js');
require('~/Content/shared/web/js/aga.init.js');
require('~/Content/shared/web/js/aga.tile.js');
require('~/Content/shared/web/js/aga.javascriptbutton.js');
require('~/Content/shared/web/js/aga.quicknav.js');
require('~/Content/shared/web/js/aga.tableCreator.js');
require('~/Content/shared/web/js/aga.memo.js');
require('~/Content/shared/web/js/aga.toastr.js');
require('~/Content/shared/web/js/aga.userconfirmation.js');
require('~/Content/shared/web/js/aga.schedule.js');
require('~/Content/shared/web/js/aga.searchhider.js');
require('~/Content/shared/web/js/aga.jargon.js');
require('~/Content/shared/web/js/table.export.js');

// Remove Vue/Vuex do window para evitar detecção pelo Wappalyzer
require('~/content/js/remove-vue-from-window.js');